
export const isBlankString = (value?: string): boolean => {
    return value === null || value === undefined || value?.trim() === '';
};

export const isNotBlankString = (value?: string): boolean => !isBlankString(value);